import { render, staticRenderFns } from "./wxCom.vue?vue&type=template&id=5b0ac1b5&scoped=true"
import script from "./wxCom.vue?vue&type=script&lang=js"
export * from "./wxCom.vue?vue&type=script&lang=js"
import style0 from "./wxCom.vue?vue&type=style&index=0&id=5b0ac1b5&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b0ac1b5",
  null
  
)

export default component.exports